<section class="main-section">

  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin/sellerDashboard/">Home</a></li>
      <li class="breadcrumb-item active" aria-current="page">Products</li>
    </ol>
  </nav>



  <div class="invalid-feedback d-block shift-invalid-text w-75" [hidden]="!errorMessage">{{errorMessage}}</div>
  <div *ngIf="totalRecords>0">
    <div class="row align-items-center">
      <div class="col-6">
        <ul class="list-inline tab-list deskContent">
          <ng-container *ngFor="let om of inventoriesMainMenu">
            <li *ngIf="om.additional === 'N'" class="list-inline-item">
              <a (click)="populateTabData(om.tabClicked,om.orderStatus); tabChange();"
                 [ngClass]="{'active': tabClicked === om.tabClicked}">{{om.displayName}}</a></li>
          </ng-container>
         <!-- <li class="list-inline-item">
            <a data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">+ more</a>
            <div class="dropdown-menu dropdown-menu2">
              <ng-container *ngFor="let om of inventoriesMainMenu">
                <a *ngIf="om.additional === 'Y'" class="dropdown-item"
                   (click)="populateTabData(om.tabClicked,om.orderStatus);switchPosition(om)"
                   [ngClass]="{'active': tabClicked === om.tabClicked}">{{om.displayName}}</a>
              </ng-container>
            </div>
          </li>-->
        </ul>
      </div>
      <div class="col-6 ml-auto text-right float-right">
        <div class="btn-group" role="group" aria-label="Basic example">
          <a placement="bottom" ngbTooltip="Upload" data-toggle="modal" data-target="#uploadModal" class="ml-2">
            <!--<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
              <defs>
                <style>.a {
                  fill: #8a55bb;
                }
                .b {
                  fill: #fff;
                }
                </style>
              </defs>
              <g transform="translate(4 2.5)">
                <rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/>
                <path class="b"
                      d="M.457,8.222A.458.458,0,0,0,0,8.679v.914a.458.458,0,0,0,.457.457h3.2V8.222ZM14.417,3,11.622.2a.685.685,0,0,0-.485-.2h-.174V3.654h3.654V3.48A.683.683,0,0,0,14.417,3Zm-4.368.885V0H4.339a.684.684,0,0,0-.685.685V8.222H7.309V6.361a.458.458,0,0,1,.782-.323L10.82,8.793a.486.486,0,0,1,0,.685L8.088,12.23a.458.458,0,0,1-.782-.323V10.049H3.654v3.883a.684.684,0,0,0,.685.685h9.593a.684.684,0,0,0,.685-.685V4.568H10.734A.687.687,0,0,1,10.049,3.883Z"
                      transform="translate(3.356 5.479)"/>
              </g>
            </svg>-->

            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="30" height="30" viewBox="0 0 30 30" version="1.1">
              <defs>
                <style>.a {
      fill: #8a55bb;
      }
      .b {
      fill: #fff;
      }
   </style>
              </defs>
              <g transform="translate(5 4.5)">
                <rect class="a" width="30" height="30" rx="4" transform="translate(-5 -4.5)"/>
                <path class="b" d="M 9.804688 0.855469 C 9.75 0.871094 9.652344 0.914062 9.589844 0.949219 C 9.523438 0.980469 8.300781 2.183594 6.867188 3.621094 C 4.492188 6 4.261719 6.246094 4.21875 6.40625 C 4.050781 7.042969 4.566406 7.597656 5.195312 7.460938 L 5.410156 7.414062 L 7.265625 5.5625 C 8.285156 4.542969 9.136719 3.710938 9.152344 3.710938 C 9.167969 3.710938 9.179688 6.109375 9.179688 9.042969 C 9.179688 14.214844 9.183594 14.382812 9.253906 14.523438 C 9.585938 15.171875 10.484375 15.148438 10.757812 14.484375 C 10.8125 14.355469 10.820312 13.742188 10.820312 9.023438 C 10.820312 6.101562 10.832031 3.710938 10.847656 3.710938 C 10.863281 3.710938 11.714844 4.542969 12.734375 5.5625 L 14.589844 7.414062 L 14.804688 7.460938 C 15.433594 7.597656 15.949219 7.042969 15.78125 6.40625 C 15.738281 6.246094 15.507812 6 13.132812 3.621094 C 11.664062 2.148438 10.464844 0.976562 10.382812 0.933594 C 10.210938 0.84375 9.945312 0.808594 9.804688 0.855469 Z M 9.804688 0.855469 "/>
                <path class="b" d="M 1.4375 10.867188 C 1.195312 10.933594 0.949219 11.183594 0.875 11.429688 C 0.785156 11.738281 0.816406 15.585938 0.910156 15.980469 C 1.285156 17.535156 2.363281 18.660156 3.847656 19.042969 C 4.363281 19.175781 4.773438 19.183594 10.273438 19.167969 C 16.195312 19.152344 15.824219 19.167969 16.488281 18.941406 C 17.578125 18.574219 18.53125 17.632812 18.917969 16.546875 C 19.148438 15.886719 19.148438 15.890625 19.167969 13.710938 C 19.1875 11.433594 19.1875 11.394531 18.941406 11.117188 C 18.570312 10.699219 17.910156 10.761719 17.628906 11.242188 L 17.519531 11.425781 L 17.5 13.535156 C 17.476562 15.578125 17.476562 15.652344 17.394531 15.871094 C 17.097656 16.65625 16.601562 17.140625 15.820312 17.40625 C 15.613281 17.476562 15.375 17.480469 10 17.480469 C 4.605469 17.480469 4.386719 17.476562 4.179688 17.40625 C 3.695312 17.242188 3.320312 16.988281 3.019531 16.632812 C 2.835938 16.414062 2.597656 15.902344 2.542969 15.609375 C 2.515625 15.460938 2.5 14.660156 2.5 13.433594 L 2.5 11.492188 L 2.390625 11.285156 C 2.210938 10.9375 1.808594 10.761719 1.4375 10.867188 Z M 1.4375 10.867188 "/>
              </g>
            </svg>

          </a>
          <a placement="bottom" ngbTooltip="Import" (click)="openButtonPopUp()" class="ml-2">
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
              <defs>
                <style>.a {
                  fill: #8a55bb;
                }
                .b {
                  fill: #fff;
                }
                </style>
              </defs>
              <g transform="translate(4 2.5)">
                <rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/>
                <path class="b"
                      d="M.457,8.222A.458.458,0,0,0,0,8.679v.914a.458.458,0,0,0,.457.457h3.2V8.222ZM14.417,3,11.622.2a.685.685,0,0,0-.485-.2h-.174V3.654h3.654V3.48A.683.683,0,0,0,14.417,3Zm-4.368.885V0H4.339a.684.684,0,0,0-.685.685V8.222H7.309V6.361a.458.458,0,0,1,.782-.323L10.82,8.793a.486.486,0,0,1,0,.685L8.088,12.23a.458.458,0,0,1-.782-.323V10.049H3.654v3.883a.684.684,0,0,0,.685.685h9.593a.684.684,0,0,0,.685-.685V4.568H10.734A.687.687,0,0,1,10.049,3.883Z"
                      transform="translate(3.356 5.479)"/>
              </g>
            </svg>
          </a>
          <a placement="bottom" ngbTooltip="Create" class="ml-2">
            <svg xmlns="http://www.w3.org/2000/svg" (click)="createProduct()" width="30" height="30"
                 viewBox="0 0 30 30">
              <defs>
                <style>.a {
                  fill: #8a55bb;
                }
                .b {
                  fill: #fff;
                }
                </style>
              </defs>
              <g transform="translate(4 2.5)">
                <rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/>
                <path class="b"
                      d="M8.563.563a8,8,0,1,0,8,8A8,8,0,0,0,8.563.563Zm4.645,8.9a.388.388,0,0,1-.387.387H9.853v2.968a.388.388,0,0,1-.387.387H7.659a.388.388,0,0,1-.387-.387V9.853H4.3a.388.388,0,0,1-.387-.387V7.659A.388.388,0,0,1,4.3,7.272H7.272V4.3a.388.388,0,0,1,.387-.387H9.466a.388.388,0,0,1,.387.387V7.272h2.968a.388.388,0,0,1,.387.387Z"
                      transform="translate(2.823 3.938)"/>
              </g>
            </svg>
          </a>
        </div>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="totalRecords===0">
    <div class="col">
      <div class="inner-box no-listbox">
        <div class="row align-items-center">
          <div class="col-md-6 text-center text-md-right">
            <img src="assets/images/Emptyscreen - Products.png">
          </div>
          <div class="col-md-6">
            <h2>Be the one to start</h2>
            <h1 class="f-46 text-orange">Create your first Product!!</h1>
            <div class="col-md-3">
              <a (click)="createProduct()">
                <button class="btn btn-orange-prime mt-4">Create now</button>
              </a>
            </div>
            <div class="col-md-3">
              <a (click)="openButtonPopUp()">
                <button class="btn btn-orange-prime mt-4">Import Products</button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div [hidden]="!totalRecords">
    <div class="row">
      <div class="col">
        <div class="inner-box d-none d-sm-block">
          <table class="table" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
            <thead>
            <tr>
              <th>SKU</th>
              <th>Product Name</th>
              <th>Product Type</th>
              <th>Creation Date</th>
              <th>HSN</th>
              <th><span>Status</span></th>
            </tr>
            </thead>
            <tbody class="table-body-custom">
            <tr *ngFor="let p of productsList;let i=index;">
              <td><a routerLink="/admin/sellerProductsView/{{p.productId}}" (cbOnSuccess)="copied($event)" ngxClipboard
                     [cbContent]="p.sku" style="text-transform:uppercase;">{{p.sku}}</a></td>
              <td>
                <div class="textminwid" ngxClipboard [cbContent]="p.productName"
                     ngbTooltip="{{p.productName | titlecase}}" (cbOnSuccess)="copied($event)">{{p.productName}}
                </div>
              </td>
              <td>{{p.productType | titlecase}}</td>
              <td>{{p.createdDate}}</td>
              <td>{{p.hsnCode | titlecase}}</td>
              <td>
                <div class="toggle-2">
                  <input type="checkbox" name="onoffswitch" (click)="changeStatus(p,i)"
                         id="customSwitch_{{p.productId}}"
                         [checked]="p.status==='ACTIVE'" class="checkbox"/>
                  <label for="customSwitch_{{p.productId}}" class="toggle">
                    <span>ON</span><span>OFF</span>
                  </label>
                </div>
              </td>
            </tr>
            </tbody>
            <tfoot *ngIf="totalCount == 0">
            <td colspan="6">No Records Found</td>
            </tfoot>
          </table>
          <div class="display-msg text-center">
            {{displayMsg}}
          </div>
        </div>
      </div>
    </div>
  </div>
</section>


<div  class="modal" [ngClass]="{'modal': buttonModal == 'Y'}"
      [ngStyle]="{'display': buttonModal =='Y'? 'block' : 'none'}"  aria-hidden="true"
      aria-labelledby="exampleModalLabel" class="modal" id="myProfile" tabindex="-1">
  <div class="modal-dialog">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Select Products</h4>
        <button type="button" (click)="closeButtonPopUp()" class="close">&times;</button>
      </div>
      <div class="modal-body ml-2">
        <div class="form-radio mr-5">
          <input type="radio" name="skuConfig" [(ngModel)]="selectImport" (click)="removeFile()"
                 [ngModelOptions]="{standalone: true}" id="importProducts" required value="PRODUCTS">
          <label for="importProducts">Import Products
          </label>
        </div>
      </div>

      <div class="modal-body ml-2" *ngIf="selectImport === 'PRODUCTS'">
        <h4 style="padding-inline:7px;">Import Products</h4>
        <div>
          <p style="font-size:15px; padding-inline:7px;">To import your Products, please create a CSV file with
            following details and upload.
            <br/>Sample file can be accessed <a
              href="https://shift-images.s3.ap-south-1.amazonaws.com/ao_products_import.csv" target="_blank">here</a>
          </p>
          <div class="row">
            <div class="col" style="height:44px; padding-right:23px;">
              <label class="import_products add_file">
                <input class="shift-import-input" type="file" (change)="loadorder($event)" [(ngModel)]="productImage"
                       [ngModelOptions]="{standalone: true}" name="file" accept="application/csv+json"/>
                <span *ngIf="!productImage || productImage == ''"> <img src="/./assets/images/Group_1645.svg"
                                                                        style="margin-right: 10px;" alt="productImage">Add file</span>
                <span *ngIf="productImage"><img src="/./assets/images/xx.png" style="margin-right: 10px;width:20px;"
                                                (click)="removeFile()" alt="productImage">{{getFileName(productImage)}}</span>

              </label>
              <div id="statusText2" class="invalid-feedback d-block mb-2" [hidden]="!statusText2">{{statusText2}}</div>
              <button type="button" *ngIf="productImage" style="margin-bottom:50px;"
                      class="btn btn-orange file shift-import ml-2" [attr.data-dismiss]="uploadDismissModal"
                      (click)="submitImportProduct()" data-toggle="modal" [attr.data-target]="uploadPopup">
                Import
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal fade" id="uploadModal" role="dialog">
  <div class="modal-dialog">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Upload Image</h4>
        <button type="button" (click)="reset()" class="close" data-dismiss="modal">&times;</button>
      </div>
      <div class="modal-body ml-2">
        <div class="white-box mb-4">
          <div class="row mt-sm-2">
            <div class="col-md-3 mb-3" *ngFor="let im of imgUrl">
              <div class="attachlist" *ngIf="im !== ''">
                <img src="{{im}}" width="100" height="100" style="width: 100px;height: 100px;"/>
                <!--<button (click)="deleteImage(im)" class="btn btn-cancel"
                        style="width: 200px!important;border-radius: 0px;"><i class="fa fa-trash-o"
                                                                              style="font-size: 16px;"></i></button>-->
              </div>
            </div>
            <div class="col-md-6 mb-3">
              <div class="attachlist">
                <input type="file" class="form-control" placeholder="100" id="imageUrl" (change)="loadImage($event)"
                       multiple>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 text-right mb-3">
              <button class="btn btn-cancel element-style" type="button" (click)="reset()" data-dismiss="modal">OK</button>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>


